import {
  Show,
  SimpleShowLayout,
  NumberField,
  FunctionField,
  BooleanField,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableField, DateTimeField } from "../../../../shared/fields";

export const RoundShow = () => (
  <Show>
    <SimpleShowLayout>
      <CopyableField source="roundId" label="Round ID" sortable={false} />
      <FunctionField
        label="State"
        render={(r: { state?: string }) => <StatusChip value={r?.state} />}
      />
      <NumberField source="crashPoint" label="Crash Point" />
      <CopyableField source="serverSeed" label="Server Seed" sortable={false} />
      <CopyableField
        source="fairnessHash"
        label="Fairness Hash"
        sortable={false}
      />
      <DateTimeField source="initializedAt" label="Initialized" />
      <DateTimeField source="startedAt" label="Started" />
      <DateTimeField source="bettingClosingStartedAt" label="Betting Closing" />
      <DateTimeField source="flyingStartedAt" label="Flying Started" />
      <DateTimeField source="crashedAt" label="Crashed" />
      <NumberField
        source="bettingOpenDurationMillis"
        label="Betting Open (ms)"
      />
      <NumberField
        source="bettingClosingDurationMillis"
        label="Betting Closing (ms)"
      />
      <NumberField source="crashedDurationMillis" label="Crashed (ms)" />
      <BooleanField source="markedForOutbox" label="Marked for Outbox" />
      <DateTimeField source="createdAt" label="Created" />
      <DateTimeField source="updatedAt" label="Updated" />
    </SimpleShowLayout>
  </Show>
);
